const Mn = require('backbone.marionette');
const Template = require('common/ui/template/login-buttons.hbs');

module.exports = Mn.View.extend({
    template: Template,

    serializeData: function () {
        const currentLocation = window.location.pathname + window.location.search + window.location.hash;
        const encodedDestinationURL = encodeURIComponent(currentLocation);
        const loginUrl = `/login?dst_url=${encodedDestinationURL}`;
        const params = new URLSearchParams(location.search);

        return {
            loginUrl: loginUrl,
            loginUrlForGoogle: `${loginUrl}&provider=google`,
            loginUrlForQuadcept: `${loginUrl}&provider=quadcept`,
            idLogin: params.get("idLogin"),
            loginUrlForIdLogin: `${loginUrl}&idLogin=1`,
        }
    }
});




// WEBPACK FOOTER //
// ./common/ui/view/login-buttons.js